import { render, staticRenderFns } from "./FormTextareaElement.vue?vue&type=template&id=a12baf42&scoped=true"
import script from "./FormTextareaElement.vue?vue&type=script&lang=js"
export * from "./FormTextareaElement.vue?vue&type=script&lang=js"
import style0 from "./FormTextareaElement.vue?vue&type=style&index=0&id=a12baf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12baf42",
  null
  
)

export default component.exports